import * as React from 'react';
import '../Order/styles.css';
import Close from '@material-ui/icons/Close';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { Loader } from '../Loader/Loader';
import { observer } from 'mobx-react';

export interface ISyncRadaroConfirmDialogProps {
    onCancel(): void
    onOk(): void
}

@observer
export class SyncRadaroConfirmDialog extends React.Component<ISyncRadaroConfirmDialogProps> {
    public render() {
        return <div className="full-dialog">
            <Loader area="sync-radaro-dialog" />
            <div className="dialog-content">
                <h3>Sync All Jobs to Radaro</h3>
                <p>This will sync all jobs for the selected date to Radaro. This process may take a few minutes to complete. Are you sure you want to continue?</p>
            </div>
            <div className="dialog-actions">
                <div className="close" onClick={() => this.props.onCancel()}>
                    <span>Cancel</span>
                    <Close className="icon" />
                </div>
                <div className="done" onClick={() => this.props.onOk()}>
                    <span>Continue</span>
                    <ArrowForward className="icon" />
                </div>
            </div>
        </div>
    }
}
